import {GetterTree} from 'vuex'
import {CallCenterUsersState} from './types';
import {RootState} from '@/store/types';

export const getters: GetterTree<CallCenterUsersState, RootState> = {
  callCenterUsers(state) {
    return state.callCenterUsers;
  },
  callCenterUserItem(state) {
    return state.callCenterUserItem;
  },
};
